/**
 * Deterministic distinct-colour generator for medication names.
 * Hashing a normalised drug name to a fixed palette guarantees:
 *  - The SAME medication ALWAYS gets the same colour across the whole UI.
 *  - DIFFERENT medications get visually-distinct colours.
 *
 * Palette is hand-picked for accessibility on light & dark themes
 * (sufficient saturation + contrast vs. both stone-50 and slate-900).
 */
const MED_PALETTE = [
  { bg: "#7C3AED", text: "#FFFFFF" },  // violet
  { bg: "#0EA5E9", text: "#FFFFFF" },  // sky
  { bg: "#059669", text: "#FFFFFF" },  // emerald
  { bg: "#DC2626", text: "#FFFFFF" },  // red
  { bg: "#D97706", text: "#FFFFFF" },  // amber
  { bg: "#DB2777", text: "#FFFFFF" },  // pink
  { bg: "#0891B2", text: "#FFFFFF" },  // cyan
  { bg: "#65A30D", text: "#FFFFFF" },  // lime
  { bg: "#9333EA", text: "#FFFFFF" },  // purple
  { bg: "#EA580C", text: "#FFFFFF" },  // orange
  { bg: "#0D9488", text: "#FFFFFF" },  // teal
  { bg: "#4F46E5", text: "#FFFFFF" },  // indigo
  { bg: "#BE185D", text: "#FFFFFF" },  // rose
  { bg: "#7C2D12", text: "#FFFFFF" },  // brown
  { bg: "#1D4ED8", text: "#FFFFFF" },  // blue
];

const hash = (str) => {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = ((h << 5) - h) + str.charCodeAt(i);
    h |= 0; // 32-bit int
  }
  return Math.abs(h);
};

export const getMedicationColor = (name) => {
  if (!name) return MED_PALETTE[0];
  const key = String(name).trim().toLowerCase();
  return MED_PALETTE[hash(key) % MED_PALETTE.length];
};
